import { ONCOKB_TM } from 'app/config/constants';

export const FDA_L1_DISABLED_BTN_TOOLTIP = `Since ${ONCOKB_TM} does not include any CDx claims prescriptive for a specific therapeutic product, by definition, no variants in ${ONCOKB_TM} are considered FDA Level 1.`;
